import { Tab, TabGroup } from '@components/Tab';
import { Button } from '@components/Button';
import { IconLogout } from '@components/icons';
import { Logo } from '@components/Logo';
import { ThemeSwitcher } from '@components/ThemeSwitcher';
import styles from './Header.module.scss';

export interface HeaderTab {
  label: string;
  active: boolean;
  onClick?: () => void;
}

export interface HeaderProps {
  /** Show logout button */
  showLogout?: boolean;

  /** Show theme switcher button */
  showThemeSwitcher?: boolean;

  /** Show tab navigation */
  showTabs?: boolean;

  /** Logo color variant - defaults to 'auto' which switches based on theme */
  logoVariant?: 'black' | 'white' | 'auto';

  /** Logout click handler */
  onLogout?: () => void;

  /** Tab configuration */
  tabs?: HeaderTab[];
}

export const Header = ({
  showLogout = true,
  showThemeSwitcher = true,
  showTabs = false,
  logoVariant = 'auto',
  onLogout,
  tabs = [
    { label: 'Overview', active: true },
    { label: 'Generate Leads', active: false },
    { label: 'Manage Leads', active: false },
  ],
}: HeaderProps) => {
  return (
    <header className={styles.header}>
      <div className={styles.wrapper}>
        <div className={styles.container}>
          <div className={styles.logo}>
            <Logo variant={logoVariant} />
          </div>
          <div className={styles.actions}>
            {showLogout && (
              <Button variant="secondary" size="small" leadingIcon={<IconLogout size={18} />} onClick={onLogout}>
                Logout
              </Button>
            )}
            {showThemeSwitcher && <ThemeSwitcher />}
          </div>
        </div>
      </div>
      {showTabs && (
        <div className={styles.tabsContainer}>
          <TabGroup className={styles.tabs}>
            {tabs.map((tab, index) => (
              <Tab key={index} label={tab.label} active={tab.active} onClick={tab.onClick} />
            ))}
          </TabGroup>
        </div>
      )}
    </header>
  );
};
